export default __webpack_public_path__ + "static/media/logo-icon.7595bc75.svg";